import BoltIcon from "@mui/icons-material/Bolt";
import StatCard from "../../ui/cards/StatCard";
import { useGetSecureVolumeCustomersQuery } from "../../../store/services/secureVolumeService";
import { WorkProgressStateEnum } from "../../../store/types/secureVolume.types";
import { useGetCurrentUserQuery } from "../../../store/services/userService";

const SecureVolumeCard = () => {
  const { data = [], isFetching } = useGetSecureVolumeCustomersQuery();
  const { data: currentUser } = useGetCurrentUserQuery();

  const myCustomers = currentUser
    ? data.filter((c) => c.AssignedTo?.Id === currentUser.ExternalUserId)
    : data;

  const done = myCustomers.filter(
    (c) => c.WorkProgressState >= WorkProgressStateEnum.ContractSigned
  ).length;

  const percent =
    myCustomers.length > 0 ? Math.round((done / myCustomers.length) * 100) : 0;

  const subtitle =
    myCustomers.length > 0
      ? `${done} av ${myCustomers.length} klara (${percent}%)`
      : "Inga kunder tilldelade";

  return (
    <StatCard
      icon={<BoltIcon />}
      title="Säkra Volym"
      color="#e67e22"
      description={`${myCustomers.length} kunder`}
      subtitle={subtitle}
      to="/secure-volume"
      loading={isFetching}
    />
  );
};

export default SecureVolumeCard;
